module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_home-9b5283171733dc7de7a38edcd0aa39b6.svg";